module.exports = __webpack_public_path__ + "img/illustration-australia.28e2e9b3.svg";